export const DESKTOP_APP = 'desktopApp';
export type DESKTOP_APP = typeof DESKTOP_APP;

export const REQUEST_NOTIFY_GO_LIVE_RUNDOWN = `${DESKTOP_APP}/requestNotifyGoLiveRundown`;
export type REQUEST_NOTIFY_GO_LIVE_RUNDOWN = typeof REQUEST_NOTIFY_GO_LIVE_RUNDOWN;
